<template>
    <van-swipe class="swiper banner-class" :autoplay="5000" v-if="params.length>0">
        <van-swipe-item v-for="(item, index) in params" :key="index">
            <van-image
                    class="swiper-img"
                    fit="fill"
                    @click="onClick(item.link)"
                    :src="item.img"
            />
        </van-swipe-item>
    </van-swipe>
</template>

<script>
    import { Swipe, SwipeItem,Image as VanImage} from 'vant';
    export default {
        name: "banner",
        components: {
            [Swipe.name]: Swipe,
            [SwipeItem.name]: SwipeItem,
            [VanImage.name]:VanImage
        },
        props:{
            params:Array
        },
        methods: {
            onClick(link) {
                if(!!link){
                    this.$router.push(link);
                }

                // this.util.carouselUrl(e.target.dataset.link);
            },
        },
    }
</script>

<style scoped>
    .swiper{
        height: 154px;
    }
    .swiper-img{
        width: 100%;
        height: 100%;
        border-radius: 5px;
        overflow: hidden;
    }
    .swiper-img >>> .van-image__img{
        border-radius: 5px;
    }
</style>
